import CTAButton from 'components/homepage/experiment/cta-button'
import Image from 'next/legacy/image'
import Navbar from '../navbar'
import {
  faInstagram,
  faLinkedin,
  faSquareFacebook,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import s from './styles.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Section from '../section'
import CardList from '../section/card-list'
import cx from 'classnames'
import Card from '../section/card'
import BulletIcon from '../icons/bullet'
import Footer from '../footer'
import { Button } from 'components/design-system'
import { ArrowRightIcon } from 'components/design-system/kickoff-icons'
import { Author as AuthorType, Post, TopNav } from '../../../types/blog-types'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { useRouter } from 'next/router'

const mainCategory = post =>
  post.fields.categories
    ? post.fields.categories.filter(({ fields }) => !fields.parent)
    : []

interface AuthorProps {
  topNav: TopNav
  footer: any
  author: AuthorType
  posts: [Post]
}

export default function Author({ topNav, author, posts, footer }: AuthorProps) {
  const { route } = useRouter()
  const authorOrExpert = route
    .split('/')
    .find(r => r === 'author' || r === 'expert')

  if (!author || !posts) return null
  return (
    <div>
      <Navbar template={topNav} />
      <main>
        <header className={s.header}>
          <div className={cx(s.authorSection, s.desktop)}>
            <div className={s.authorSectionLabel}>
              <span>Kickoff {authorOrExpert}</span>
            </div>
            <h2 className={s.name}>{author.fields.name}</h2>
            <p className={s.bio}>{author.fields.bio}</p>
            {/* <CTAButton
              className={s.cta}
              analyticProps={{ location: `${author.name} Author Page` }}>
              Free Consultation
            </CTAButton> */}
            <Button to="/blog/editorial-guidelines" className={s.cta}>
              Read our Editorial Guidelines
              <ArrowRightIcon />
            </Button>
            {/* <hr className={s.hr} /> */}
            <div className={s.icons}>
              {author.fields.facebookUrl && (
                <a href={author.fields.facebookUrl || ''}>
                  <FontAwesomeIcon
                    icon={faSquareFacebook as any}
                    color="#830051"
                    className={s.icon}
                  />
                </a>
              )}
              {author.fields.instagramUrl && (
                <a href={author.fields.instagramUrl || ''}>
                  <FontAwesomeIcon
                    icon={faInstagram as any}
                    color="#830051"
                    className={s.icon}
                  />
                </a>
              )}
              {author.fields.twitterUrl && (
                <a href={author.fields.twitterUrl || ''}>
                  <FontAwesomeIcon
                    icon={faTwitter as any}
                    color="#830051"
                    className={s.icon}
                  />
                </a>
              )}
              {author.fields.youtubeUrl && (
                <a href={author.fields.youtubeUrl || ''}>
                  <FontAwesomeIcon
                    icon={faYoutube as any}
                    color="#830051"
                    className={s.icon}
                  />
                </a>
              )}
              {author.fields.linkedInUrl && (
                <a href={author.fields.linkedInUrl || ''}>
                  <FontAwesomeIcon
                    icon={faLinkedin as any}
                    color="#830051"
                    className={s.icon}
                  />
                </a>
              )}
              {author.fields.personalWebsiteUrl && (
                <a href={author.fields.personalWebsiteUrl || ''}>
                  <FontAwesomeIcon
                    icon={faLink as any}
                    color="#830051"
                    className={s.icon}
                  />
                </a>
              )}
            </div>
          </div>
          <div className={s.imageWrapper}>
            {author.fields.profileImage &&
              author.fields.profileImage.fields && (
                <Image
                  alt={author.fields.profileImage.fields.title}
                  src={`https:${author.fields.profileImage.fields.file.url}`}
                  layout="fill"
                  objectFit="cover"
                />
              )}
          </div>
          <div className={cx(s.authorSection, s.mobile)}>
            <div className={s.authorSectionLabel}>
              <span>Kickoff Author</span>
            </div>
            <h2 className={s.name}>{author.fields.name}</h2>
            <p className={s.bio}>{author.fields.bio}</p>
            <CTAButton
              className={s.cta}
              analyticProps={{ location: `${author.fields.name} Author Page` }}>
              Free Consultation
            </CTAButton>
            <hr className={s.hr} />
            <div className={s.icons}>
              <a href={author.fields.facebookUrl || ''}>
                <FontAwesomeIcon
                  icon={faSquareFacebook as any}
                  color="#830051"
                  className={s.icon}
                />
              </a>
              <a href={author.fields.facebookUrl || ''}>
                <FontAwesomeIcon
                  icon={faInstagram as any}
                  color="#830051"
                  className={s.icon}
                />
              </a>
              <a href={author.fields.facebookUrl || ''}>
                <FontAwesomeIcon
                  icon={faTwitter as any}
                  color="#830051"
                  className={s.icon}
                />
              </a>
              <a href={author.fields.facebookUrl || ''}>
                <FontAwesomeIcon
                  icon={faYoutube as any}
                  color="#830051"
                  className={s.icon}
                />
              </a>
            </div>
          </div>
        </header>
        <Section title="Qualifications & Interests" className={s.section}>
          <div className={s.qualificationSection}>
            <div>
              <span className={s.qualificationTitle}>Education</span>
              <div>
                <ul>
                  {author.fields.education?.map((education, i) => (
                    <li key={`${education}-${i}`}>
                      <BulletIcon />
                      <span>{education}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div>
              <span className={s.qualificationTitle}>Specialties</span>
              <div>
                <ul>
                  {author.fields.specialties?.map((specialty, i) => (
                    <li key={`${specialty}-${i}`}>
                      <BulletIcon />
                      {specialty}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div>
              <span className={s.qualificationTitle}>Activities & Honors</span>
              <div>
                <ul>
                  {author.fields.activitiesAndHonors?.map((activity, i) => (
                    <li key={`${activity}-${i}`}>
                      <BulletIcon />
                      {activity}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Section>
        {posts && !!posts.length && (
          <Section title="Articles" className={s.section}>
            <CardList type="vertical">
              {posts.map(post => {
                return (
                  <Card
                    key={`articles-${post.sys.id}`}
                    className={s.articles}
                    post={post}
                    categories={mainCategory(post)}
                  />
                )
              })}
            </CardList>
          </Section>
        )}
      </main>
      <Footer items={footer} />
    </div>
  )
}
